import styled from 'styled-components';

export const ReferralCodeUploaderContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 16px;
    padding: 24px;
    border-radius: 8px;
    border: 1px solid #e9ecef;
    
    h3 {
        margin: 0;
        color: #333;
        font-size: 18px;
        font-weight: 600;
    }
`;

export const InputContainer = styled.div`
    display: flex;
    gap: 12px;
    align-items: flex-end;
    
    @media (max-width: 768px) {
        flex-direction: column;
        align-items: stretch;
    }
`;

export const ButtonContainer = styled.div`
    flex-shrink: 0;
`;
